import { FILTERS_GET_DATA, FILTERS_GET_PARAMS, FILTERS_GET_VALUES, FILTERS_SHOULD_RELOAD } from './types';

export const getters = {
    [FILTERS_GET_DATA]: state => {
        return state.data;
    },
    [FILTERS_GET_PARAMS]: state => {
        return state.params;
    },
    [FILTERS_GET_VALUES]: state => {
        return state.values;
    },
    [FILTERS_SHOULD_RELOAD]: state => {
        return state.reload;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/getters.js